import { ChangeDetectorRef, Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { DocumentLibraryConstants } from '../document-library-constants';
import { DocumentPreviousPhase } from '../models/documentPreviousPhase';
import { DocumentDetail } from '../models/documentVersionDetail';
import { NextPhase } from '../models/nextPhase';
import { DocumentService } from '../services/document.service';
import { DocumentDetailDto } from '../../shared/models/document-details-dto';
import { DocumentAttachmentDetails } from '../models/document-attachment-details';
import { DocumentPersistenceService } from '../services/document-persistence.service';
import { DocumentFormattedFile } from '../models/DocumentFormattedFile';
import { DocumentFormattedFileEdit } from '../models/DocumentFormattedFileEdit';
import { PhaseValueConstants } from '../../../app/shared/constants/phaseValues-constants';
import { catchError, takeUntil, throwError, timer, Subject, forkJoin } from 'rxjs';
import { DocumentReadAudit } from '../models/document-read-audit';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { IEQMSScopeLookUpDetails } from '../../shared/models/scopes/eqms-Scope-lookup-details';
import { LabelConstants } from '../../shared/constants/label-constants';
import { NameCode } from '../../shared/models/name-code';
import { CurriculumTrainingItemGroupsLookupRequest } from '../../shared/components/curriculum-training-item-group-management/models/curriculum-training-item-groups-lookup-request';
import { TrainingItemGroupWithScheduled } from '../../shared/models/TrainingItemGroupWithScheduled';
import { DocumentTrainingComponent } from '../document-training/document-training.component';
import { PollCompletionService, PollResult } from '../../core/services/poll-completion.service';

@Component({
  selector: 'app-document-details',
  templateUrl: './document-details.component.html',
  styleUrls: ['./document-details.component.scss'],
})
export class DocumentDetailsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  constructor(
    private documentsservice: DocumentService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private documentPersistenceService: DocumentPersistenceService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private cd : ChangeDetectorRef,
    private pollCompletionService: PollCompletionService
  ) {
    // Subscribe to poll completion events
    this.pollCompletionService.completion$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result: PollResult) => {
          this.handlePollCompletion(result);
        }
      });
  }
  @Input() isDocumentSliderOpen: boolean = false;
  @ViewChild(DocumentTrainingComponent)
  private documentTraining!: DocumentTrainingComponent;
  isDocumentAttachmentsExists: boolean = false;
  isChangeRequestHistoryModalShow: boolean = false;
  documentDetail: DocumentDetail = {} as DocumentDetail;
  number!: string;
  version!: number;
  isEffective!: boolean;
  isCreateChangeRequestItemSliderOpen: boolean = false;
  isRequestedEffectiveDateModal: boolean = false;
  isFormattedDocumentPreviewButtonVisible: boolean = false;
  showPhaseButton: boolean = false;
  showReviewStatusButton: boolean = false;
  showRequestedEffectiveDateModal: boolean = false;
  counter: number = 2;
  showPreviousPhaseButton: boolean = false;
  isReasonForChangeModal: boolean = false;
  isDocumentFavourite: boolean = false;
  previousPhases: number[] = [1, 2, 3, 4, 5];
  messages: Message[] = [];
  documentNextPhase!: NextPhase;
  isReviewersPanelModal: boolean = false;
  documentPreviousPhase!: DocumentPreviousPhase;
  isTrainingItemGroupManagementSliderOpen : boolean = false;
  isShowDocumentLinkModal: boolean = false;
  isLatestDocument: boolean = false;
  isDocumentFound: boolean = true;
  isDocumentVersionFound: boolean = true;
  latestVersionLink!: string;
  showApprovalStatusButton: boolean = false;
  isApproversPanelModal: boolean = false;
  isEffectiveVersionSearch: boolean = false;
  documentErrorMsg!: string;
  FavoriteIcon!: string;
  documentDetailsDto!: DocumentDetailDto;
  showCancelButton: boolean = false;
  isCancelModal: boolean = false;
  isDeactiveModal: boolean = false;
  showUncancelButton: boolean = false;
  showDeactivateButton: boolean = false;
  showEffectiveNowButton: boolean = false;
  showDelegateButton: boolean = false;
  isPageFound: boolean = true;
  viewHistoryModal = false;
  isDelegateSliderOpen = false;
  checkedOutUserInfo:any;
  displayCheckoutIcon=true;
  displayFileCheckedOutIcon=false;
  editDocumentAvailableForUser=false;
  isCRIReviewActionsAvailable=false;
  isInternalClientContactLimitedAccess: boolean = false;
  documentAttachments: DocumentAttachmentDetails[] = [];
  documentAttachmentsLoaded = false;
  isRequestedEffectiveDateToBeDisplayed: boolean = false;
  isEffectiveDateToBeDisplayed: boolean = false;
  readonly requiredPhasesToCheck = [1, 2, 3, 4];
  topBarTitle: string = DocumentLibraryConstants.DocumentDetailsTitle;
  fileId!: string;
  fileName!: string;
  isLoggedInUserAdmin: boolean = false;
  documentFormattedFile!: DocumentFormattedFile;
  documentFormattedFileEdit !: DocumentFormattedFileEdit;
  cancelledDocumentPhaseConstant: any = PhaseValueConstants.Cancelled;
  formattingDocumentPhaseConstant: any = PhaseValueConstants.Formatting;
  isFileCheckinModalShow: boolean = false;
  activeIndex: number = 0;
  errorMessage:string|undefined= undefined;
  eQMSScopeLookUp:any[] = [];
  isDocumentProficiencyQuizSliderOpen: boolean = false;
  showLoadDocumentDetailsConfirmationDialog = false;
  loadDocumentDetailsMessage = DocumentLibraryConstants.Document_Slider_Confirmation_Text_For_Approved_Or_EffectivePhase;
  eQMSScopesList :IEQMSScopeLookUpDetails[] = [];
  quizAttemptsAvailable:any;
  quizDataForDocument:any;
  isProfciencyQuizRequiredForUser:boolean=false;
  showConfirmationModalOnClickOfUpdateEffectiveDateBtn : boolean = false;
  confirmationTextForUpdateEffectiveDate : string = DocumentLibraryConstants.UpdateEffectiveDate_ConfirmationText;
  reasonForEffectiveDateUpdate : string= '';
  validationMessageForReasonForChangingEffectiveDate : string = DocumentLibraryConstants.Document_ReasonForChangingEffectiveDate;
  headingForUpdateEffectiveDate : string = DocumentLibraryConstants.ReasonForChangingEffectiveDateValidationMessage;
  isDocumentVersionDateModalVisible : boolean = false;
  displayESignForDocDetailsUpdate:boolean = false;
  documentDetailsLoader = true;
  previewFormattedFileID !:string
  ifCommentsPresent: boolean = false;
  isShowDocumentCommentModal : boolean = false;
  isCurriculumTrainingItemGroupManagementSliderOpen : boolean = false;
  trainingItemGroups !: any;
  trainingItemGroupsForDocument:TrainingItemGroupWithScheduled[] = [];
  trainingItemGroupsLookupRequest! : CurriculumTrainingItemGroupsLookupRequest;
  curriculumsLookupRequest!: CurriculumTrainingItemGroupsLookupRequest;
  fileType: string = '';
  openPdfPreviewModal : boolean = false;
  readOnlyFileUrl:string = '';
  curriculumsForActiveDocumentTrainingItem: NameCode[] = [];
  curriculumsForScheduledDocumentTrainingItem: NameCode[] = [];

  ngOnInit(): void {
    this.documentPersistenceService.reloadDetails$.subscribe((reload) => {
      if (reload) {
        this.reloadDocumentData();
      }
    });
    let url = this.router.url;
    let santizedUrl = url.split("?")[0];
    let docParts = santizedUrl.substring(santizedUrl.lastIndexOf('/') + 1, santizedUrl.length);
    if (santizedUrl.includes('/eqms.documentDetails/')) {
      if (docParts.includes(':')) {
        this.number = docParts.substring(0, docParts.indexOf(':'));
        let docVersion = docParts.substring(
          docParts.indexOf(':') + 1,
          docParts.length
        );
        if (docVersion == 'latest') this.isLatestDocument = true;
        else if (docVersion == undefined ||
          isNaN(Number(docVersion))
          || Number(docVersion) < 0) {
          this.isPageFound = false;
        } else this.version = Number(docVersion); 
        this.isEffective = false;
      } else {
        this.number = docParts;
        this.isEffective = true;
      }
      if (this.isPageFound) this.initialize();
    }
    this.documentsservice.checkIsDocumentFavorite(this.number).subscribe((data) => this.isDocumentFavourite = data);

    const timeout = timer(15000); 
    const subscription = this.documentsservice.editDocumentMetaDataLoaded$
      .pipe(takeUntil(timeout))
      .subscribe((isDataLoaded) => {
        if (isDataLoaded) {
          this.documentDetailsLoader = false;
          clearTimeout(fallbackTimeout);
        }
      });
  
    // We will have the below fall back to trigger after 10 seconds of wait time to stop the loadr
    const fallbackTimeout = setTimeout(() => {
      this.documentDetailsLoader = false;
      subscription.unsubscribe();
    }, 20000);
  }

  setDocumentLoader($event : any) {
    this.documentDetailsLoader = $event;
    if(!this.documentDetailsLoader) {
    this.reloadDocumentData();
    }
  }

  hideorShowRequestedEffectiveDateModal() {
    this.showRequestedEffectiveDateModal =
      this.documentDetail.phase === 0 ? true : false;
  }


  hideOrShowDelegateButton() {
    this.showDelegateButton = false;
    if(!this.documentDetail.isGlobalDocument){
    if (this.documentDetail.isLatestVersion == true && (this.isIncludesLoggedInUser(this.documentDetail.reviewers.map(reviewer => reviewer.assignedUserName)) == true
      || this.isIncludesLoggedInUser(this.documentDetail.approvers.map(approver => approver.assignedUserName)) == true || (this.isIncludesLoggedInUser(this.documentDetail.periodicReviewers.map(periodicReviewer => periodicReviewer.assignedUserName)) == true))) {
      this.showDelegateButton = true;
    }
  }
  }

  isIncludesLoggedInUser(userArray: string[]): boolean {
    if (userArray != null) {
      return userArray.some(element => {
        return element.toLowerCase() === this.documentDetail.loggedInUser.toLowerCase();
      })
    } else {
      return false;
    }
  }

  addDelegation() {
    this.isDelegateSliderOpen = !this.isDelegateSliderOpen;
  }

  closeDelegateSlider(isSliderActive: boolean) {
    this.isDelegateSliderOpen = isSliderActive;
  }
  

  validateAndDisplayRequestedEffectiveDate() {
    if (this.requiredPhasesToCheck.indexOf(this.documentDetail.phase) !== -1) {
      this.isRequestedEffectiveDateToBeDisplayed = true;
      this.isEffectiveDateToBeDisplayed = false;
    }
    else {
      this.isRequestedEffectiveDateToBeDisplayed = false;
      this.isEffectiveDateToBeDisplayed = true;
    }

  }

  initialize() {
    this.latestVersionLink = location.origin.concat(
      '/eqms.documentDetails/',
      this.number,
      ':latest'
    );
    this.loadDocumentDetails();
  }

  getTrainingItemGroups(){
    this.documentsservice.getTrainingItemGroupForDocument(this.number).subscribe((response)=>{
      this.trainingItemGroups = response;
      this.trainingItemGroupsForDocument = this.trainingItemGroups;
    })
  }

  getCurriculums(){
    this.documentsservice.getCurriculumsForActiveDocumentTrainingItem(this.number).subscribe((response)=>{
      this.curriculumsForActiveDocumentTrainingItem = response;
    })
  }

  getScheduledCurriculums(){
    this.documentsservice.getCurriculumsByScheduledTrainingItem(this.number).subscribe((response)=>{
      this.curriculumsForScheduledDocumentTrainingItem = response;
    })
  }

  reloadDocumentData() {
    this.initialize();
    this.activeIndex = 0;
  }

  hideOrShowFormattedDocumentPreviewButton() {
    this.isFormattedDocumentPreviewButtonVisible = false;
    if (this.documentDetail.phase == 2) {
      this.isFormattedDocumentPreviewButtonVisible = true;
    }
  }

  reloadDocumentPageOnCheckOut($event: any) {
    this.latestVersionLink = location.origin.concat(
      '/eqms.documentDetails/',
      this.number,
      ':latest'
    );
    this.loadDocumentDetails();
    this.checkedOutUserInfo = this.documentDetail.checkedOutUser;
  }


  private loadDocumentDetails() {
    if (this.isLatestDocument === true) {
      this.documentsservice.getLatestDocumentDetail(this.number).subscribe({
        next: (serviceData) => {
          this.documentDetail = serviceData
        },
        error: (err) => {
          if (err.status === LabelConstants.NotFound_StatusCode) {
            if (err.error && err.error.type) {
              if (err.error.type === DocumentLibraryConstants.NoDocumentFoundError) {
                this.isDocumentFound = false;
              }
              this.setErrorMessage(this.documentErrorMessage());
            }
          }
          if (err.status === LabelConstants.Forbidden_StatusCode) {
            if (err.error && err.error.detail)
              this.setErrorMessage(err.error.detail);
          }
           this.isDocumentFound = false
        },
        complete: () => {
          this.setPageData();
          this.documentDetailsLoader = false;
        },
      });
    } else if (this.version !== undefined && this.version !== null && this.version >= 0) {
      this.documentsservice
        .getDocumentDetailByVersion(this.number, this.version)
        .subscribe({
          next: (serviceData) => {
            this.documentDetail = serviceData
            },
          error: (err) => {
            if (err.status === LabelConstants.NotFound_StatusCode) {
              if (err.error && err.error.type) {
                if (err.error.type === DocumentLibraryConstants.NoDocumentVersionFoundError) {
                  this.isDocumentFound = true;
                  this.isDocumentVersionFound = false;
                }
                else if (err.error.type === DocumentLibraryConstants.NoDocumentFoundError) {
                  this.isDocumentFound = false;
                }
                this.setErrorMessage(this.documentErrorMessage());
              }
            }
            if (err.status === LabelConstants.Forbidden_StatusCode) {
              if (err.error && err.error.detail)
                this.setErrorMessage(err.error.detail);
            } this.isDocumentFound = false
          },
          complete: () => {
            this.documentPersistenceService.updateDocumentVersionDetails(this.documentDetail);
            this.setPageData();
            this.documentDetailsLoader = false;
          },
        });
    } else {
      this.documentsservice
        .getDocumentDetail(this.number, this.isEffective)
        .subscribe({
          next: (serviceData) => {
            this.documentDetail = serviceData
          },
          error: (err) => {
            if (err.status === LabelConstants.NotFound_StatusCode) {
              if (err.error && err.error.type) {
                if (err.error.type === DocumentLibraryConstants.NoEffectiveVersionFoundError) {
                  this.isDocumentFound = true;
                }
                else if (err.error.type === DocumentLibraryConstants.NoDocumentFoundError) {
                  this.isDocumentFound = false;
                }
                this.setErrorMessage(this.documentErrorMessage());
              }
            }
            if (err.status === LabelConstants.Forbidden_StatusCode) {
              if (err.error && err.error.detail)
                this.setErrorMessage(err.error.detail);
            } this.isDocumentFound = false
          },
          complete: () => {
            this.documentPersistenceService.updateDocumentVersionDetails(this.documentDetail);
            this.setPageData();
            this.documentDetailsLoader = false;
          },
        });
    }
  }
  setErrorMessage = (errorMessage:string) : void => {
    let documentNumbers = errorMessage.substring(errorMessage.indexOf("[") + 1,errorMessage.indexOf("]"));
    let errorMessageToDisplay = errorMessage.substring(0,errorMessage.indexOf("["))
    if(documentNumbers.length > 0){
      let scopeIds = documentNumbers.split(",");
      this.loadeQMSScopes();
      let scopeNames:string[] = []
      scopeIds.forEach(scopeId => {
        let scopeName = this.eQMSScopesList.find(scope => scope.eQMSScopeId === Number(scopeId))?.eQMSScopeName;
        if(!!scopeName)scopeNames.push(scopeName);
      });
      let scopeNamesToDisplay = scopeNames.join(", ")
      errorMessageToDisplay = errorMessageToDisplay.concat(" - " ,scopeNamesToDisplay);
    }
    this.errorMessage = errorMessage.indexOf("[") == -1 ? errorMessage :errorMessageToDisplay;
  }
  setPageData() {
    this.generateDocumentDetailsDto();
    this.hideorShowRequestedEffectiveDateModal();
    this.validateAndDisplayRequestedEffectiveDate();
    this.getDocumentSourceFile();
    this.hideOrShowDelegateButton();
    this.setIsLoggedInUserAdmin();
    this.hideOrShowFormattedDocumentPreviewButton();
    this.checkAndSetFileCheckoutInformation();
    this.checkIfDocumentCommentsAreAvailable();
    this.setInternalClientContactLimitedAccess();
  }

  setInternalClientContactLimitedAccess() {
    const isUserInternalClientContact = this.documentDetail.internalClientContacts?.some(
      (ic) => ic.assignedUserName.toLowerCase() === this.documentDetail.loggedInUser.toLowerCase()
    ) || false;
    const hasAdminRole = this.documentDetail.assignedAdmins?.some(
      (admin) => admin.assignedUserName.toLowerCase() === this.documentDetail.loggedInUser.toLowerCase()
    ) || false;

    this.isInternalClientContactLimitedAccess = 
      this.documentDetail.phase === PhaseValueConstants.ClientSignature &&
      this.documentDetail.forbidChangesAfterInReviewTransition === true &&
      this.documentDetail.documentAuthorizationFlags.editPropertiesButton === true &&
      isUserInternalClientContact &&
      !hasAdminRole;
    
    // Set clientSignatureAttachmentVisibile for limited access users
    if (this.isInternalClientContactLimitedAccess && this.documentDetail.isClientSignatureAttachmentAvailable !== undefined) {
      this.documentPersistenceService.clientSignatureAttachmentVisibile = 
        this.documentDetail.isClientSignatureAttachmentAvailable;
      
      this.setClientSignatureAttachmentForLimitedAccess();
    }
  }

  private setClientSignatureAttachmentForLimitedAccess() {
    // For limited access users, we only need to update the client signature attachment
    this.documentPersistenceService.setClientSignatureAttachmentForLimitedAccess(
      this.documentDetail.number,
      this.documentDetail.version,
      this.documentDetail.clientSignatureAttachment
    );
  }

  checkIfDocumentCommentsAreAvailable(){
    this.ifCommentsPresent = this.documentDetail.documentComments != null;
  }
  openDocumentCommentModal(){
    this.isShowDocumentCommentModal = true;
    this.cd.detectChanges();
  }

  loadeQMSScopes = () => {
    this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((eQMSScopes)=>{
      this.eQMSScopesList = eQMSScopes
      });
  }
   
  setIsLoggedInUserAdmin() {
    if (this.documentDetail.assignedAdmins.some((assigedAdmin)=>{
        return this.documentDetail.loggedInUser.toLowerCase() === assigedAdmin.assignedUserName.toLowerCase();
    })){
      this.isLoggedInUserAdmin = true;
      this.validateAndDisplayRequestedEffectiveDate();
      this.hideOrShowDelegateButton();
    }
  };

  openCreateChangeRequestItem() {
    this.isCreateChangeRequestItemSliderOpen =
      !this.isCreateChangeRequestItemSliderOpen;
  }

  checkAndSetFileCheckoutInformation() {
    if (this.documentDetail.checkedOutUser !== null && this.documentDetail.checkedOutUser !== "null") {
      this.checkedOutUserInfo = this.documentDetail.checkedOutUser;
      this.displayFileCheckedOutIcon = true;
      this.displayCheckoutIcon = false;
      this.editDocumentAvailableForUser=this.documentDetail.loggedInUser===this.documentDetail.checkedOutUser?true:false;
      this.isCRIReviewActionsAvailable = this.checkedOutUserInfo === this.documentDetail.loggedInUser;
    }
    else {
      this.checkedOutUserInfo = this.documentDetail.checkedOutUser;
      this.displayFileCheckedOutIcon = false;
      this.displayCheckoutIcon = true;
      this.editDocumentAvailableForUser = true;
      this.isCRIReviewActionsAvailable = true;
    }
  }

  isCreateChangeRequestItemSliderActive(isSliderActive: boolean) {
    this.isCreateChangeRequestItemSliderOpen = isSliderActive;
    this.reloadDocumentData();
  }

  editDocument(): void {
    if(this.documentDetail.phase === 5 || this.documentDetail.phase === 6){
      //We call the confirmation dialog component 
      this.showLoadDocumentDetailsConfirmationDialog = true;
    }
    else{
      this.executeEditDocument();
    }
  }

  onLoadDocumentDetailsConfirmed() {
    this.showLoadDocumentDetailsConfirmationDialog = false;
    this.executeEditDocument();
  }

  onDialogClosed(value: boolean) {
    this.showLoadDocumentDetailsConfirmationDialog = value;
  }

  private executeEditDocument() {
    // Recalculate the flag right before opening the slider to ensure it's current
    this.setInternalClientContactLimitedAccess();
    this.isDocumentSliderOpen = !this.isDocumentSliderOpen;
    this.documentsservice.editDocumentSlider$.next(true);
  }

  closeEditDocumentSlider(isDocumentEditSliderActive: boolean) {
    this.isDocumentSliderOpen = isDocumentEditSliderActive;
  }
  isNextPhaseButtonClicked(): void {
    this.isRequestedEffectiveDateModal = this.showRequestedEffectiveDateModal;
  }

  displayNextPhaseButton(event: boolean): void {
    if (this.documentDetail.phase === 1 || this.documentDetail.phase === 2 || this.documentDetail.phase === 10) {
      this.confirmDialog();
    }
    this.isRequestedEffectiveDateModal = this.documentDetail.phase === 0;
  }

  unlockFile(): void {
    this.confirmDialogForUnlockFile();
  }

  displayRequestedEffectiveDateModal(event: boolean) {
    this.isRequestedEffectiveDateModal = false;
  }

  displayPreviousPhaseButton(event: boolean): void {
    this.isReasonForChangeModal = true;
  }

  documentReviewStatus() {
    this.isReviewersPanelModal = true;
  }

  documentApprovalStatus() {
    this.isApproversPanelModal = true;
  }

  displayReviewsPanelModal(event: boolean): void {
    this.isReviewersPanelModal = false;
  }

  displayApproversPanelModal(event: boolean): void {
    this.isApproversPanelModal = false;
  }
  displayReasonForChangeModal(event: boolean): void {
    this.isReasonForChangeModal = false;
  }
  displayFileCheckInModal(event: boolean): void {
    this.isFileCheckinModalShow = false;
    this.reloadDocumentData();
  }

  displayCancellationReasonModal(event: boolean): void {
    this.isCancelModal = false;
  }

  displayDeactivationModal(event: boolean): void {
    this.isDeactiveModal = false;
  }

  previewFormattedFile() {
    this.documentsservice.generateDocumentFormattedFilePreview(this.documentDetail.number, 
      this.documentDetail.version).subscribe(
      {
        next:(response) => {
      this.previewFormattedFileID = response.fileId;
      this.documentsservice.downloadFile(response.fileId).subscribe({
        next:(result) => {
        if((response.fileExtension === ".pdf" || response.fileExtension === ".PDF") &&
          this.documentDetail.printLock) {
          this.readOnlyFileUrl = result.fileUri;
          this.openPdfPreviewModal = true;
        }else{
          const fileUrl = result.fileUri;
          let downloadLink = document.createElement('a');
          document.body.appendChild(downloadLink);
          downloadLink.setAttribute('style', 'display: none');
          downloadLink.href = fileUrl;
          downloadLink.download = this.documentDetail.number + "-v" + this.documentDetail.version + " - " + this.documentDetail.title;
          downloadLink.target = '_blank';
          downloadLink.click();
          downloadLink.remove();
        }
    },
    error:()=>{
      if(response.fileId != undefined || response.fileId != null){
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: DocumentLibraryConstants.Document_PreviewFormattedFile_Failed,
          sticky : true
        })
      }
      else{
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
          sticky : true
        })
      }
    }})
  },
  error:()=>{
    if(this.previewFormattedFileID != undefined || this.previewFormattedFileID != null){
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Err,
        summary: DocumentLibraryConstants.Document_PreviewFormattedFile_Failed,
        sticky : true
      })
    }
    else{
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Err,
        summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
        sticky : true
      })
    }
  }})
  }

  confirmDialog() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.documentNextPhase = { RequestedEffectiveDate: null };
        this.documentDetailsLoader = true;
        this.documentsservice
          .moveDocumentToNextPhase(
            this.documentDetail.number,
            Number(this.documentDetail.version),
            this.documentNextPhase
          )
          .pipe(
            catchError((err) => {
              this.documentDetailsLoader = false;
              this.messageService.add({
                severity: DocumentLibraryConstants.Severity_Err,
                summary: `${err.error}`,
              });
              return throwError(() => err);
            })
          )
          .subscribe(() => {
          });
      },
      reject: () => { },
    });
  }

  private waitForFormattedFileAndReload(documentNumber: string, documentVersion: number) {
    const maxAttempts = DocumentLibraryConstants.MaxAttemptsToCheckFormattedFileStatus;
    const retryDelayMs = DocumentLibraryConstants.RetryDelayMsToCheckFormattedFileStatus;
    let attempt = 0;

    const check = () => {
      attempt++;
      this.documentsservice.getFormattedFileStatus(documentNumber, documentVersion).subscribe({
        next: (status: any) => {
          if (status && status.isReady) {
            this.messageService.add({
              severity: DocumentLibraryConstants.Severity_Info,
              summary: `${DocumentLibraryConstants.MoveToNextPhase_Success}`,
            });
            this.reloadDocumentData();
            this.documentDetailsLoader = false;
          } else if (attempt < maxAttempts) {
            setTimeout(check, retryDelayMs);
          } else {
            this.messageService.add({
              severity: DocumentLibraryConstants.Severity_Info,
              summary: DocumentLibraryConstants.MoveToNextPhaseFormattedFileGenerationStatusCheck_Failure,
              sticky: true
            });
            this.reloadDocumentData();
          }
        },
        error: () => {
          if (attempt < maxAttempts) {
            setTimeout(check, retryDelayMs);
          } else {
            this.messageService.add({
              severity: DocumentLibraryConstants.Severity_Info,
              summary: DocumentLibraryConstants.MoveToNextPhaseFormattedFileGenerationStatusCheck_Failure,
              sticky: true
            });
            this.reloadDocumentData();
          }
        }
      });
    };
    check();
  }

  confirmDialogForUnlockFile() {
    this.confirmationService.confirm({
      message: DocumentLibraryConstants.FileUnlockConfirmationMessage,
      header: 'Unlock Document',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.documentDetailsLoader = true;
        this.documentsservice
          .discardDocumentCheckoutInfo(
            this.documentDetail.number,
            Number(this.documentDetail.version)
          )
          .pipe(
            catchError((err) => {
              this.messageService.add({
                severity: DocumentLibraryConstants.Severity_Err,
                summary: `${err.error}`,
              });
              this.documentDetailsLoader = false;
              return throwError(() => err);
            })
          )
          .subscribe(() => {
            this.messageService.add({
              severity: DocumentLibraryConstants.Severity_Success,
              summary: `${DocumentLibraryConstants.FileCheckoutDiscarded_Success}`,
            });
            this.reloadDocumentData();
          });
      },
      reject: () => { },
    });
  }


  updateDocumentFavourite() {
    this.documentsservice.updateDocumentFavorite(this.documentDetailsDto.number).subscribe();
    this.isDocumentFavourite = !this.isDocumentFavourite;
  }

  openDocumentLinkModal() {
    this.isShowDocumentLinkModal = true;
  }
  isShowDocumentLinksModal(isShowDocumentLinkModal: boolean) {
    this.isShowDocumentLinkModal = isShowDocumentLinkModal;
  }

  isDocumentCommentModalShow(isShowDocumentCommentModal: boolean) {
    this.isShowDocumentCommentModal = isShowDocumentCommentModal;
  }
  openChangeRequestItemHistoryModal = () => {
    this.isChangeRequestHistoryModalShow =
      !this.isChangeRequestHistoryModalShow;
  };
  closeChangeRequestHistoryModal(isShow: boolean): void {
    this.isChangeRequestHistoryModalShow = isShow;
  }

  updateIsLatestVersion(isLatest: boolean): void {
    this.documentDetail.isLatestVersion = isLatest;
  }
  generateDocumentDetailsDto = () => {
    this.documentDetailsDto = {
      documentId: undefined,
      number: this.documentDetail?.number,
      version: this.documentDetail?.version,
      phase: this.documentDetail?.phase,
      includeQAReview: this.documentDetail.includeQAReview,
      includesClientSignature: this.documentDetail.includesClientSignature === null || undefined ? false : this.documentDetail.includesClientSignature,
      requestedEffectiveDate: this.documentDetail.requestedEffectiveDate,
      isProficiencyQuizSaveButton:this.documentDetail.documentAuthorizationFlags.documentProficiencyQuizSaveButton
    };
    if(this.documentDetail.doesDocumentHaveAttachments){
      // To get the document Attachments
    this.loadDocumentAttachments();
    }
    this.documentPersistenceService.documentNumber = this.documentDetail?.number;
    this.documentPersistenceService.documentVersion = Number(this.documentDetail?.version);

  };

  documentErrorMessage(): string {
    var url = this.router.url;
    var sanitizedUrl = url.split("?")[0];
    var docParts = sanitizedUrl.substring(sanitizedUrl.lastIndexOf('/') + 1, sanitizedUrl.length);
    if (docParts.indexOf(':') == -1 && this.isDocumentFound == true) {
      this.isEffectiveVersionSearch = true;
    }
    if (!this.isPageFound) {
      return (this.documentErrorMsg = 'Page not found');
    }
    if (this.isDocumentFound && this.isEffectiveVersionSearch) {
      this.documentErrorMsg =
        'There is no Effective Version of this Document. You can access the latest Version of the Document <a href="' +
        this.latestVersionLink +
        '" target="_blank">here</a>.';
    } else if (this.isDocumentFound) {
      this.documentErrorMsg =
        'This Document Version does not exist. You can access the latest Version of the Document <a href="' +
        this.latestVersionLink +
        '" target="_blank">here</a>.';
    } else if(!this.isDocumentFound && this.errorMessage && this.errorMessage !== null){
      this.documentErrorMsg = this.errorMessage!;
    }
    else if (!this.isDocumentFound) {
      this.documentErrorMsg = 'This Document does not exist.';
    }
    return this.documentErrorMsg;
  }
  openDocumentVersionHistoryModal() {
    this.viewHistoryModal = !this.viewHistoryModal;
  }
  closeDocumentVersionHistoryModal(): void {
    this.viewHistoryModal = false;
  }
  calculatePhaseColor = (phase: number): string => {
    let statusColor = '';
    switch (phase) {
      case 0:
        statusColor = 'collaboration';
        break;
      case 1:
        statusColor = 'qa_review';
        break;
      case 2:
        statusColor = 'formatting';
        break;
      case 3:
        statusColor = 'in_review';
        break;
      case 4:
        statusColor = 'ready_for_approval';
        break;
      case 5:
        statusColor = 'approved';
        break;
      case 6:
        statusColor = 'effective';
        break;
      case 7:
        statusColor = 'archived';
        break;
      case 8:
        statusColor = 'cancelled';
        break;
      case 9:
        statusColor = 'obsolete';
        break;
        case 10:
          statusColor = 'client_signature';
          break;
    }
    return statusColor;
  };
  loadDocumentAttachments = () => {
    this.documentsservice.getDocumentAttachments(this.documentDetailsDto.number, Number(this.documentDetailsDto.version))
      .subscribe((documentAttachments) => {
        this.documentAttachments = documentAttachments;
        this.isDocumentAttachmentsExists = this.documentAttachments.length > 0;
        this.documentAttachmentsLoaded = true;
      });
  }

  getDocumentSourceFile() {  
    this.fileType = '';  
    if (this.documentDetail.phase === PhaseValueConstants.Collaboration || this.documentDetail.phase === PhaseValueConstants.QaReview 
      || this.documentDetail.phase === PhaseValueConstants.Formatting) {
      this.documentsservice
      .getDocumentSourceFile(this.documentDetail.number,
         this.documentDetail.version)
      .subscribe({next:(documentSourceFile) => {
        this.fileId = documentSourceFile.fileId;
        this.fileName = documentSourceFile.name;
      },
      error:(error)=>{
        if(error.status === 401){
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: `${error.error}`,
          })
        }
        else if(this.documentDetail.phase === PhaseValueConstants.Collaboration ){
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.DocumentSourceFile_Creation_Failed,
            sticky:true
          })
        }
      }})
    } else if (this.documentDetail.phase !== PhaseValueConstants.Cancelled) {
      this.documentsservice.getDocumentDetailsForDocumentFormattedFile(this.documentDetail.number, 
        this.documentDetail.version)
      .subscribe({next:(documentFormattedFile) => {
        this.fileId = documentFormattedFile.fileId;
        this.fileName = documentFormattedFile.name;
        this.fileType = documentFormattedFile.fileType;
      },
      error:(error)=>{
        if(error.status === 401){
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: `${error.error}`,
          })
        }
        else if ((this.documentDetail.includesClientSignature && this.documentDetail.phase === PhaseValueConstants.ClientSignature) ||
      (!this.documentDetail.includesClientSignature && this.documentDetail.phase === PhaseValueConstants.InReview)){
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary:  DocumentLibraryConstants.File_Generation_Failed,
            sticky: true
          })
        }
      }
    })
    }
  }

  downloadSourceFile = (fileId: string, fileName: string,printLock:boolean) => {
    let formatedFileGenerationPhase = false;
    if (this.documentDetail.phase === 3 // in-review
      || this.documentDetail.phase === 5 // approved
      || this.documentDetail.phase === 6 // effective
      || this.documentDetail.phase === 10) // client signature
      { 
        formatedFileGenerationPhase = true;
      }
    if (formatedFileGenerationPhase == true) {
    setTimeout(() => {
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary:  DocumentLibraryConstants.Document_File_Availability_Status_Information
      })
    }, 50);
  }

     this.documentsservice.downloadFile(fileId).subscribe({
      next:(response) => {
        if (formatedFileGenerationPhase == true) {
        this.messageService.clear();
        }
       if ((this.fileType === ".pdf" || this.fileType === ".PDF") && printLock) {
          this.readOnlyFileUrl = response.fileUri;
          this.openPdfPreviewModal = true;
       }else{
          const fileUrl = response.fileUri;
          let downloadLink = document.createElement('a');
          document.body.appendChild(downloadLink);
          downloadLink.setAttribute('style', 'display: none');
          downloadLink.href = fileUrl;
          downloadLink.download = fileName;
          downloadLink.target = '_blank';
          downloadLink.click();
          downloadLink.remove();
       }
      },
      error:()=>{
        if (formatedFileGenerationPhase == true) {
          this.messageService.clear();
          }
        if(fileId != undefined || fileId != null){
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.Document_File_UnableToDownload,
            sticky: true
          })
        }
        else{
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
            sticky: true
          })
        }
      }
    });
    this.addAuditForDocumentReadActivity();
  }

  setCRICountButtonColor(isLatest: boolean): void {
    this.documentDetail.changeRequestItemCounter.isAnyChangeRequestItemsNotRejected = !isLatest;
  }

  getFavouriteToolTip(){
    return this.isDocumentFavourite ? DocumentLibraryConstants.ToolTipMessage_ToRemoveFromFavorite : DocumentLibraryConstants.ToolTipMessage_ToAddToFavorite ;
  }

  getCheckOutUserStatus = (): boolean => {
    return this.checkedOutUserInfo !== null;
  };

  openFileCheckInModal(): void {
    this.isFileCheckinModalShow = true;
  }

  addAuditForDocumentReadActivity = () => {
    let documentReadAuditDto: DocumentReadAudit = {
      documentNumber: this.documentDetailsDto.number,
      documentVersion: Number(this.documentDetailsDto.version),
      attributeName: "Document Source File"
    };
    this.documentsservice.addAuditForDocumentRead(documentReadAuditDto).subscribe();
  }
  openDocumentProficiencyQuizSlider = () => {
   this.isDocumentProficiencyQuizSliderOpen = true;
  }
  closeDocumentProficiencyQuizSlider = (isSliderActive: boolean) => {
    this.isDocumentProficiencyQuizSliderOpen = isSliderActive;
  }
  getQuizData=(availableQuizData:any)=>{
    this.quizDataForDocument=availableQuizData;
    this.isProfciencyQuizRequiredForUser=availableQuizData.requiresProficiencyQuiz;
    this.quizAttemptsAvailable=availableQuizData.maximumAttempts;
  }

  openConfirmationModal(){
    this.showConfirmationModalOnClickOfUpdateEffectiveDateBtn = true;
  }

  closeReasonDailog(value : boolean){    
    this.showConfirmationModalOnClickOfUpdateEffectiveDateBtn = value
  }

  saveReason(value : any){
    this.reasonForEffectiveDateUpdate = value;
    this.showConfirmationModalOnClickOfUpdateEffectiveDateBtn = false;
    this.isDocumentVersionDateModalVisible = true;
    this.displayESignForDocDetailsUpdate=true;
  }
  handleDocVersionDatesModal(event:any)
  {
    this.isDocumentVersionDateModalVisible=false;
    this.displayESignForDocDetailsUpdate=false;
  }

  downloadAttachment = (fileId: string, fileName: string) => {
    this.documentsservice.downloadFile(fileId).subscribe({
      next:(response) => {
      const fileUrl = response.fileUri;
      let downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
  },
error:()=>{
  if(fileId != undefined || fileId != null){
    this.messageService.add({
      severity: DocumentLibraryConstants.Severity_Err,
      summary: DocumentLibraryConstants.Document_File_UnableToDownload,
      sticky: true
    })
  }
  else{
    this.messageService.add({
      severity: DocumentLibraryConstants.Severity_Err,
      summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
      sticky: true
    })
  }
}})
  }
 
  openCurriculumTrainingItemGroupManagementSlider = () => {
      forkJoin({
        trainingItemGroups: this.documentsservice.getTrainingItemGroupForDocument(this.number),
        curriculums: this.documentsservice.getCurriculumsForActiveDocumentTrainingItem(this.number),
        scheduledCurriculums: this.documentsservice.getCurriculumsByScheduledTrainingItem(this.number)
      }).subscribe({
        next: (results) => {
          this.trainingItemGroups = results.trainingItemGroups;
          this.trainingItemGroupsForDocument = this.trainingItemGroups;
          this.curriculumsForActiveDocumentTrainingItem = results.curriculums;
          this.curriculumsForScheduledDocumentTrainingItem = results.scheduledCurriculums;
          this.openSlider();
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed to load training data',
            sticky: true
          });
        }
      });
  }

  private openSlider() {
    this.trainingItemGroupsLookupRequest = {trainingItemType: 1, trainingItemId: this.number, documentVersionNumber: Number(this.documentDetail.version)};
    this.curriculumsLookupRequest = {trainingItemType: 0, trainingItemId: this.number, documentVersionNumber: Number(this.documentDetail.version)};
    this.isCurriculumTrainingItemGroupManagementSliderOpen = true;
  }

  closeCurriculumTrainingItemGroupManagementSlider(isSliderActive: boolean) {
    this.isCurriculumTrainingItemGroupManagementSliderOpen = isSliderActive;
  }

  showPdfPreviewModal(isModalShow:boolean) :void {
    this.openPdfPreviewModal = isModalShow;
  }

  /**
   * Handles poll completion events from the polling service
   * Routes to appropriate handler methods based on the domain
   */
  private handlePollCompletion(result: PollResult): void {
    // Check if the polling completed successfully
    if (result.status !== 'completed') {
      // Handle non-success scenarios (timeout, not-found, error)
      // Get friendly operation name based on domain
      const operationName = this.getOperationFriendlyName(result.domain);
      this.pollCompletionService.displayPollError(result, operationName);
      return;
    }

    // Process successful completion based on domain
    switch (result.domain) {
      case 'MoveDocumentVersionToNextPhase':
        this.handleMoveToNextPhaseCompletion(result);
        break;
      case 'MoveDocumentToEffectivePhase':
      case 'MoveDocumentToApprovedPhase':
      case 'UpdateDocumentVersionApprovalStatus':
        this.handleApprovalCompletion(result);
        break;
      case 'UpdateDocument':
        this.handleUpdateDocumentCompletion(result);
        break;
      case 'MoveDocumentVersionToPreviousPhase':
        this.handleMoveToPreviousPhaseCompletion(result);
        break;
      case 'MoveDocumentVersionToApprovalPhase':
      case 'UpdateDocumentVersionReviewStatus':
        this.handleMoveToReadyForApprovalPhaseCompletion(result);
        break;
      default:
    }
  }

  /**
   * Converts domain names to user-friendly operation descriptions
   */
  private getOperationFriendlyName(domain: string): string {
    const operationNames: { [key: string]: string } = {
      'MoveDocumentVersionToNextPhase': 'moving the document to the next phase',
      'MoveDocumentToEffectivePhase': 'moving the document to the effective phase',
      'MoveDocumentToApprovedPhase': 'moving the document to the approved phase',
      'UpdateDocumentVersionApprovalStatus': 'approving the document',
      'UpdateDocument': 'updating the document',
      'MoveDocumentVersionToPreviousPhase': 'moving the document to the previous phase',
      'MoveDocumentVersionToApprovalPhase': 'moving the document to the approval phase',
      'UpdateDocumentVersionReviewStatus': 'updating the document review status'
    };
    
    return operationNames[domain] || 'processing your document request';
  }

  private handleMoveToNextPhaseCompletion(result: PollResult): void {
    if (this.documentDetail.phase === PhaseValueConstants.Formatting) {
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary: `${DocumentLibraryConstants.MoveToNextPhaseFormattedFileGeneration_Inprogress}`,
        sticky: true,
      });
      this.waitForFormattedFileAndReload(
        this.documentDetail.number,
        Number(this.documentDetail.version)
      );
    } else {
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary: `${DocumentLibraryConstants.MoveToNextPhase_Success}`,
        life : 5000
      });
      this.reloadDocumentData();
    }   
  }

  private handleMoveToPreviousPhaseCompletion(result: PollResult): void {
    this.messageService.add({
      severity: DocumentLibraryConstants.Severity_Info,
      summary: `${DocumentLibraryConstants.MoveToPreviousPhase_Success}`,
      life : 5000
    });
    this.reloadDocumentData();
  }

  private handleMoveToReadyForApprovalPhaseCompletion(result: PollResult): void {
    this.documentDetailsLoader = false;
    this.messageService.add({
      severity: DocumentLibraryConstants.Severity_Info,
      summary: `${DocumentLibraryConstants.DocumentReviewStatusUpdated_Success}`,
      life : 5000
    });
    this.reloadDocumentData();
    this.cd.detectChanges();
  }

  private handleApprovalCompletion(result: PollResult): void {
    this.documentDetailsLoader = false;
    if(result.domain === 'UpdateDocumentVersionApprovalStatus'){
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary: `${DocumentLibraryConstants.ApprovedForApprover_Success}`,
        life: 5000
      });
    } else if(result.domain === 'MoveDocumentToApprovedPhase'){
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary: `${DocumentLibraryConstants.ApprovedForApprover_Success}`,
        life: 5000
      });
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary: `${DocumentLibraryConstants.MoveToVariousPhase_Success}`,
        life : 5000
      });
    } else if(result.domain === 'MoveDocumentToEffectivePhase'){
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary: `${DocumentLibraryConstants.ApprovedForApprover_Success}`,
        life: 5000
      });
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary: `${DocumentLibraryConstants.MoveToVariousPhase_Success}`,
        life : 5000
      });
    }
    this.reloadDocumentData();
    this.isDocumentVersionDateModalVisible = false;
    this.isApproversPanelModal = false;
  }

  private handleUpdateDocumentCompletion(result: PollResult): void {
    this.documentDetailsLoader = false;
    if (this.isDocumentVersionDateModalVisible) {
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary: `${DocumentLibraryConstants.EffectiveAndPeriodicReviewDate_Updated}`,
        life: 5000
      });
      this.isDocumentVersionDateModalVisible = false;
    } else {
      this.isDocumentSliderOpen = false;
    }
    
    this.reloadDocumentData();
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
